export const USER_ROLES = {
  ADMINS: "admins",
  EDITORS: "editors",
  SPONSORS: "sponsors",
  VISITORS: "visitors",
};

export const MAP_TYPES = {
  REQUEST: "request",
  EDIT: "edit",
};

export const BOOTH_STATUSES = {
  AVAILABLE: "Available",
  BLOCKED: "Blocked",
  ASSIGNED: "Assigned",
};

export const ERRORS = {
  SERVER: "server",
  CREDENTIALS: "credentials",
  LINK_EXPIRED: "expired",
  LINK_INVALID: "invalid",
  PASSWORDS: "passwords",
};
